export const lgElectronics = require('assets/images/services/lgElectronics.png');
export const fortressPower = require('assets/images/services/fortressPower.png');
export const sonnen = require('assets/images/services/sonnen.png');
export const siemensEnergy = require('assets/images/services/siemensEnergy.png');
